// https://evergreen.segment.com/components/search-input
// https://evergreen.segment.com/components/select
import { SearchInput, Select } from "evergreen-ui";
import { MUSEUMS } from "./api";

function Search({ query, onChange, museum, onMuseumChange }) {
  return (
    <div className="search-bar">
      <label htmlFor="museum-select" className="sr-only">
        Museum
      </label>
      <Select
        id="museum-select"
        value={museum}
        onChange={onMuseumChange}
        width={260}
        flex="none"
        className="museum-select"
      >
        {MUSEUMS.map((m) => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </Select>
      <SearchInput
        placeholder="Enter search term, for example: cats"
        width="100%"
        autoFocus
        value={query}
        onChange={onChange}
        maxLength={100} // 🛡️ SECURITY: Limit input length to prevent massive string processing
      />
    </div>
  );
}

export default Search;
